import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import '@/styles/global.css';
import '@/styles/toastification.css';
import HqApi from './lib/HqApi';
import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
import Notifier from './plugins/notifier'

const app = createApp(App);

app.use(router);
app.use(store);
app.use(vuetify);
app.config.globalProperties.$hqapi = HqApi.getInstance();
app.config.globalProperties.$store=store;
app.component('Table', () => import('@/components/Table.vue'));
app.component('DateRangePicker', () => import('@/components/DateRangePicker.vue'));
app.component('Select', () => import('@/components/Select.vue'));
app.component('TextBox', () => import('@/components/TextBox.vue'));
app.component('Autocomplete', () => import('@/components/Autocomplete.vue'));
app.component('EasyDataTable', Vue3EasyDataTable);
app.use(Notifier, { store: store });

app.mount('#app');